export interface IFilterClause {
  operator: FilterOps;
}

export interface ILeafFilterClause extends IFilterClause {
}

export interface ICompositeFilterClause extends IFilterClause {
  clauses: ILeafFilterClause[];
}

export interface IStringValuedFilterClause extends ILeafFilterClause {
  value: string;
  operator:
    FilterOps.and
    | FilterOps.eq
    | FilterOps.lt
    | FilterOps.lte
    | FilterOps.gt
    | FilterOps.gte
    | FilterOps.has
    | FilterOps.matches;
}

export interface IFieldFilterClause extends ILeafFilterClause {
  field: string;
}

export interface IValuedFieldFilterClause<T> extends IFieldFilterClause {
  value: T;
  operator:
    FilterOps.and
    | FilterOps.eq
    | FilterOps.lt
    | FilterOps.lte
    | FilterOps.gt
    | FilterOps.gte
    | FilterOps.has
    | FilterOps.matches;
}

export type IStringValuedFieldFilterClause = IStringValuedFilterClause & IFieldFilterClause;

export interface IStringArrayValuedFieldFilterClause<T extends string = string> extends IFieldFilterClause {
  values: ReadonlyArray<T>;
  operator: FilterOps.inArray;
}

export enum FilterOps {
  and     = 'and',
  eq      = 'eq',
  lte     = 'lte',
  lt      = 'lt',
  gt      = 'gt',
  gte     = 'gte',
  has     = 'has',
  inArray = 'in',
  matches = 'matches'
}

/**
 * These are the server-side filter names, which are sent to various backend APIs. They are converted
 * from the client-side filters in ServerFilterClauses.ts.
 */
export const FilterFieldNames = {
  accelerationStatus:  'accelerationStatus',
  authentication:       'authentication',
  collectionVisibility: 'visibility',
  completedAt:          'completedAt',
  connectionType:       'connectionType',
  containerType:        'containerType',
  contentType:          'contentType',
  createdAt:            'createdAt',
  createdTime:          'createdTime',
  databaseUsername:     'databaseUsername',
  datasourceId:         'datasourceId',
  discardIdentity:      'discardIdentity',
  domainId:             'domainId',
  domainName:           'domainName',
  extractStatus:        'extractStatus',
  failureType:          'failureType',
  favoriteCollections:  'favorite',  // this is used to filter on favorite collections, according to AIPs favorite should be used over isFavorite
  flowId:               'flowId',
  flowOutputStepName:   'flowOutputStepName',
  groupId:              'groupId',
  groupIds:             'groupIds',
  hasActiveDataQualityWarning: 'hasActiveDataQualityWarning', // the crass version of the 'hasActiveWarning' field
  hasActiveWarning:     'hasActiveWarning',
  hasAlert:             'hasAlert',
  hasEmbeddedPassword:  'hasEmbeddedPassword',
  hasExtracts:          'hasExtracts',
  includeLiveToDataEngine: 'includeLiveToDataEngine',
  isCertified:          'isCertified',
  isDefaultPort:        'isDefaultPort',
  isEmbedded:           'isEmbedded',
  isFavorite:           'isFavorite',
  isPublished:          'isPublished',
  isRecent:             'isRecent',
  lastRefreshedAt:      'lastRefreshedAt',
  location:             'location',
  luid:                 'luid',
  maxSiteRole:          'maxSiteRole',
  minimumSiteRole:      'minimumSiteRole',
  name:                 'name',
  ownerId:              'ownerId',
  ownerUserName:        'ownerUserName',
  parentId:             'parentId',
  parentProjectId:      'parentProjectId',
  parentType:           'parentType',
  permissionedItemCount: 'permissionedItemCount',
  projectId:            'projectId',
  publishedConnectionId: 'publishedConnectionId',
  scheduledAction:      'scheduledAction',
  scheduleId:           'scheduleId',
  serverName:           'serverName',
  serverPort:           'serverPort',
  showSystemJobs:       'showSystemJobs',
  siteId:               'siteId',
  siteRole:             'siteRole',
  startedAt:            'startedAt',
  status:               'status',
  tags:                 'tags',
  taskType:             'taskType',
  timeRange:            'timeRange',
  topLevelProject:      'topLevelProject',
  updatedAt:            'updatedAt',
  updatedTime:          'updatedTime',
  urlName:              'repositoryUrl',
  userId:               'userId',
  workbookConnFilter:   'workbookConnFilter',
  workbookId:           'workbookId',
};
